import { generatePath } from 'react-router'
import CardLink from 'src/components/MUIBased/CardLink'
import { useAmpli, useNavigation } from 'src/hooks'
import { AppointmentProfile, Clinic } from 'src/types'
import { BOOKING_STEPS } from 'src/pages/MUIBased/Appointments/hooks/useBookingFlow'

interface LocationCardProps {
    clinic: Clinic
    offering: AppointmentProfile
}

const formatLocationName = (clinic: Clinic) => {
    if (clinic.name.startsWith('Tia ')) {
        return clinic.name
    }

    if (clinic.isVirtual) {
        return 'Tia Virtual'
    }

    return `Tia ${clinic.name}`
}

const LocationCard = ({ clinic, offering }: LocationCardProps) => {
    const { navigate } = useNavigation()
    const { preSlotSearchLocationSelected } = useAmpli()

    const handleAppointmentClicked = () => {
        preSlotSearchLocationSelected(clinic.name)
        navigate(
            `${generatePath(BOOKING_STEPS.deeplink.path, {
                appointmentProfileUuid: offering.appointmentProfileUuid
            })}${`?clinicUuids=${clinic.uuid}&backTo=/appointments`}`
        )
    }
    return (
        <CardLink
            onClick={handleAppointmentClicked}
            label={formatLocationName(clinic)}
        />
    )
}

export default LocationCard
